'use client';
import styled from 'styled-components';

export const GrayBar = styled.div`
  background: ${({ theme }) => theme.palette.gray.light};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  padding-block: 1.88rem;
  border-top: 3px solid ${({ theme }) => theme.custom.colors.brand};
  padding: 1rem;
`;
